import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useCashPaymentsLogic } from './hooks/useCashPaymentsLogic';
import { CashPaymentsForm } from './CashPaymentsForm';

export const EddCashPayments = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useCashPaymentsLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={tCommon('sectionTitles.businessActivity')}
        text={t('organic.cashPayments.title')}
        textCustomStyle='mt-[16px] text-text-main-primary text-[16px] whitespace-pre-line'
        headingContainerCustomStyle='!mb-[16px]'>
        <CashPaymentsForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
